module.exports = __webpack_public_path__ + "img/小弹窗(2).69c3094f.jpg";